<template>
  <div class="mx-auto">
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
    />
    <div class="container row">
      <div class="col-12 col-md-2">
        <span class="data-title d-block border-mobile">Año Académico:</span>
        <span class="font-16 color-black">
          {{ model.academicYear | empty }}
        </span>
      </div>
      <div class="col">
        <span class="data-title d-block border-mobile">Estatus:</span>
        <div class="d-flex align-items-center">
          <span
            class="dot"
            :class="`color-dot-${getContractTemplateStatusColor(model.status)}`"
          />
          <span class="font-16 ml-1">
            {{ model.statusDescription | empty }}
          </span>
        </div>
      </div>
    </div>
    <div class="container row mt-4">
      <div class="col-12">
        <span class="data-title d-block border-mobile">
          Servicio(s) Seleccionado(s):
        </span>
        <span
          v-for="(service, index) of model.selectedServices"
          :key="index"
          class="font-16 chip badge px-3 py-2 mr-2"
        >
          {{ service.name }}
        </span>
      </div>
    </div>
    <hr class="my-4 mx-3" />
    <div class="mx-auto px-4">
      <template v-for="(item, index) of model.historyTemplates">
        <history-row
          :key="index"
          :index="index"
          :is-mobile="isMobile"
          :item="item"
        />
      </template>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import HistoryRow from './components/HistoryRow.vue';
import store, { modulesName } from '@/store/index';
import { getDetails as _getDetails } from '@/services/provider/contract-document-configuration.api';
import { getContractTemplateStatusColor as _getContractTemplateStatusColor } from '@/utils/constants/contractTemplateStatus';

export default {
  name: 'ContractTemplateHistory',
  components: {
    PageHeader,
    HistoryRow,
  },
  data() {
    return {
      model: {
        academicYear: null,
        status: null,
        statusDescription: null,
        selectedServices: [],
        historyTemplates: [],
      },
    };
  },
  computed: {
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
    contractTemplateId() {
      return +this.$route.params?.contractTemplateId || null;
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left fa-fw',
          variant: 'outline-success',
          click: () =>
            this.$router.push({ name: 'contractDocumentConfigurationSearch' }),
        },
      ];
    },
    headerConfig() {
      return {
        title: 'Historial de Modificaciones',
        icon: 'fas fa-user-tie',
        routes: [
          'Inicio',
          'Proveedor',
          'Configuración de Documento de Contrato',
        ],
      };
    },
  },
  mounted() {
    _getDetails(this.contractTemplateId).then(({ data }) => {
      if (data) {
        this.model = {
          academicYear: data.yearDescription,
          status: data.statusId,
          selectedServices: data.services,
          historyTemplates: data.history,
          statusDescription: data.statusDescription,
        };
      }
    });
  },
  methods: {
    getContractTemplateStatusColor(contractTemplateStatusId) {
      return _getContractTemplateStatusColor(contractTemplateStatusId);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

$lightWhite: #b7c4bd;

.chip {
  border: 1px solid $lightWhite;
  border-radius: 16px;
  display: inline-block;
}
.dot {
  height: 16px;
  width: 16px;
  border-radius: 50%;
}
.color-dot-gray {
  background-color: map-get($colors, 'gray');
}
.color-dot-green-light {
  background-color: map-get($colors, 'green-light');
}
</style>
